import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import DashboardAside from "@/pages/dashboard/components/dashboard-aside/dashboard-aside.vue";
import DashboardOverview from "@/pages/dashboard/partials/dashboard-overview/dashboard-overview.vue";
import DashboardInformations from "@/pages/dashboard/partials/dashboard-informations/dashboard-informations.vue";
import DashboardNetworks from "@/pages/dashboard/partials/dashboard-networks/dashboard-networks.vue";
import DashboardPassword from "@/pages/dashboard/partials/dashboard-password/dashboard-password.vue";

import { mapState } from "vuex";

export default {
    beforeMount() {
        this.$store.dispatch('dashboard/fetchUserProfile', {
            'userId': this.$store.state.user.currentUser.uid
        });
    },
    components: {
        DashboardPassword,
        DashboardNetworks,
        DashboardInformations,
        DashboardOverview,
        DashboardAside,
        top,
        navigation,
        bottom
    },
    computed: {
        ...mapState('dashboard', {
            activeTab: state => state.activeTab,
        }),
    },
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/master/dashboard.js